module.exports = __webpack_public_path__ + "img/message_7.5ed931aa.png";